<div *ngIf="!isAd" class="player-options horizontal-focusable-container">
  <div *ngIf="showSubtitles" class="player-options-button focusable-element" tabindex="0"
  (click)="openSubtitlesMenu()" (focus)="focusOption(0)" (mouseover)="mouseEnterOptions($event, 0)">
    <app-icon name="subtitles"></app-icon>
    <p>{{ 'player.subtitles' | translate }}</p>
  </div>
  <div *ngIf="(isLive || currentResource?.contentType === 'channel') && !isLiveEvent" class="player-options-button focusable-element" tabindex="0"
  (click)="openEpg()" (focus)="focusOption(1)" (mouseover)="mouseEnterOptions($event, 1)">
    <app-icon name="epg"></app-icon>
    <p>{{ 'player.epg' | translate }}</p>
  </div>

  <div *ngIf="currentResource?.isSeries" class="player-options-button focusable-element" tabindex="0"
  (click)="openEpisodes()" (focus)="focusOption(2)" (mouseover)="mouseEnterOptions($event, 2)">
    <app-icon name="episodes"></app-icon>
    <p>{{ 'player.episodes' | translate }}</p>
  </div>

  <div *ngIf="resourceVmUpNext" class="player-options-button focusable-element" tabindex="0"
  (click)="suggestedNextClick()" (focus)="focusOption(3)" (mouseover)="mouseEnterOptions($event, 3)">
    <app-icon name="next-episode"></app-icon>
    <p>{{ 'player.nextEpisode' | translate }}</p>
  </div>
</div>
